import React, { FC, Fragment } from 'react';
import { TerritoryTabTitle } from './TerritoryTabTitle';
import { TerritoryTabListItem } from './TerritoryTabListItem';
import { TerritoryTab } from './TerritoryTab';
import { TerritorySelectedTab } from './constants';
import DotSeparator from '../CommentsSection/Comment/DotSeparator';
import { TerritoryVersionType } from '../../layouts/TerritoryPageLayout/TerritoryPageLayout';

type TTerritoryTabListProps = {
  territoryName: string;
  activeTab: TerritorySelectedTab;
  onClick: (tab: TerritorySelectedTab) => void;
  isSidebarOpen?: boolean;
  territoryVersion: TerritoryVersionType;
};

const getTerritoryTabList = (territoryVersion: TerritoryVersionType) => [
  { tab: TerritorySelectedTab.explore, label: 'Explore', shouldDisplay: true },
  { tab: TerritorySelectedTab.community, label: 'Community', shouldDisplay: true },
  { tab: TerritorySelectedTab.rewards, label: 'Rewards', shouldDisplay: territoryVersion === TerritoryVersionType.V2 },
];

export const TerritoryTabList: FC<TTerritoryTabListProps> = ({
  activeTab,
  onClick,
  territoryName,
  isSidebarOpen,
  territoryVersion,
}) => (
  <div className="flex items-baseline overflow-x-auto no-scrollbar">
    {!isSidebarOpen && <TerritoryTabTitle>{territoryName}</TerritoryTabTitle>}
    <ul className="flex gap-4 items-center">
      {getTerritoryTabList(territoryVersion)
        .filter(({ shouldDisplay }) => shouldDisplay)
        .map((tabItem, index) => {
          const isLastTab =
            index === getTerritoryTabList(territoryVersion).filter(({ shouldDisplay }) => shouldDisplay).length - 1;
          return (
            <Fragment key={tabItem.label}>
              <TerritoryTabListItem onClick={() => onClick(tabItem.tab)}>
                <TerritoryTab activeTab={activeTab === tabItem.tab}>{tabItem.label}</TerritoryTab>
              </TerritoryTabListItem>
              {!isLastTab && (
                <li>
                  <DotSeparator className="!block" />
                </li>
              )}
            </Fragment>
          );
        })}
    </ul>
  </div>
);
